import React, { useState, useEffect, useCallback, useRef } from "react";

import { connect } from "react-redux";
import qs from "qs";
import axios from "axios";
import { appConifg } from "../../config/default";
import {
  AsyncTypeahead,
  Highlighter,
  Menu,
  MenuItem,
  Typeahead,
} from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import {
  fetchAddressResultRequest,
  fetchAddressResultSuccess,
  fetchAddressResultFailure,
} from "../../redux/actions/addressingResultActions";
import { clearAddressDetails } from "../../redux/reducers/addressDetailsReducer";
import { useDispatch } from "react-redux";

import {
  addressingApiResponseMapper,
  addressDetailsMapper,
} from "../mappers/addressingMappers";

import {
  getPointAddressSuggestions,
  getStreetAddressSuggestions,
  getAreaAddressSuggestions,
  getPostalAddressSuggestions,
  getAddressCandidateByMkey,
  getAddressCandidateByText,
  getAddressDetailsFromParcelId,
} from "../../serviceClients/addressingClient";
import { Fragment } from "react";

import { setSidePanelStatusAndResultType } from "../../redux/actions/mapPanelControlActions";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

// const mapSearchBarStyle = {
//   position: "fixed",
//   marginTop: "60px",
//   //right: "15px",
//   marginLeft: "53px",
//   marginRight: "53px",
//   width: "30rem",
//   zIndex: "999",
//   maxWidth: "50%",
// };

const useStyles = makeStyles((theme) => ({
  mapSearchBarDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block",
      position: "fixed",
      marginTop: "60px",
      //right: "15px",
      marginLeft: "53px",
      marginRight: "53px",
      width: "30rem",
      zIndex: "999",
      maxWidth: "50%",
    },
  },
  mapSearchBarMobile: {
    display: "block",
    position: "fixed",
    marginTop: "60px",
    //right: "15px",
    marginLeft: "53px",
    marginRight: "53px",
    width: "30rem",
    zIndex: "999",
    maxWidth: "80%",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

const getParms = (params) =>
  Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");

function MapSearchBar(props) {
  const classes = useStyles();
  const { t, i18n } = useTranslation("mapPage");
  const reduxDispatch = useDispatch();
  var hObje = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
  const store_appToken =
    props.appSettings &&
    props.appSettings.userCredentials &&
    props.appSettings.userCredentials.token
      ? props.appSettings.userCredentials.token.access_token
      : null;

  const [suggestionsState, setSuggestionsState] = useState({
    isLoading: false,
    options: [],
    query: " ",
  });
  const searchBarRef = useRef(null);

  useEffect(() => {
    if (!props.mapSearchValueDummy) return;
    console.log("clear the value  map search bar text");
    searchBarRef && searchBarRef.current.clear() && searchBarRef.current.blur(); //Bad way to clear map search bar text
  }, [props.mapSearchValueDummy]);

  const removeLastPartARE = (txt) => {
    if (!txt) return;
    var restArry = txt.split(",");
    restArry.pop();
    return restArry.toString();
  };

  const handleSuggestionSearch = (query) => {
    if (!query || query.trim().length === 0) return;
    query = query.trim();

    setSuggestionsState({
      ...suggestionsState,
      options: [],
      isLoading: true,
    });

    const [p1, c1] = getPointAddressSuggestions(
      query,
      props.appSettings.language
    );
    const [p2, c2] = getStreetAddressSuggestions(
      query,
      props.appSettings.language
    );
    const [p3, c3] = getAreaAddressSuggestions(
      query,
      props.appSettings.language
    );
    const [p4, c4] = getPostalAddressSuggestions(
      query,
      props.appSettings.language
    );

    axios
      .all([p1, p2, p3, p4])
      .then((response) => {
        var sug0 = []; //TODO : remove the last part ",ARE " from the locator
        if (response[0].data.error) {
          console.log(
            "Unable to Reterieve Point AddressSuggestions ",
            response[0].data.error.code,
            response[0].data.error.message
          );
        }
        if (response[1].data.error) {
          console.log(
            "Unable to Reterieve Streets Suggestions ",
            response[0].data.error.code,
            response[0].data.error.message
          );
        }
        if (response[2].data.error) {
          console.log(
            "Unable to Reterieve Areas Suggestions ",
            response[0].data.error.code,
            response[0].data.error.message
          );
        }
        if (response[3].data.error) {
          console.log(
            "Unable to Reterieve Postal Locality Suggestions ",
            response[0].data.error.code,
            response[0].data.error.message
          );
        }

        var sug1 = response[0].data.suggestions
          ? response[0].data.suggestions.map((i) => ({
              ...i,
              suggestionType: "Point Addresses",
              text: removeLastPartARE(i.text),
            }))
          : [];

        var sug2 = response[1].data.suggestions
          ? response[1].data.suggestions.map((i) => ({
              ...i,
              suggestionType: "Streets",
              text: removeLastPartARE(i.text),
            }))
          : [];

        var sug3 = response[2].data.suggestions
          ? response[2].data.suggestions.map((i) => ({
              ...i,
              suggestionType: "Areas",
              text: removeLastPartARE(i.text),
            }))
          : [];

        var sug4 = response[3].data.suggestions
          ? response[3].data.suggestions.map((i) => ({
              ...i,
              suggestionType: "Postal Locality",
              text: removeLastPartARE(i.text),
            }))
          : [];

        // var sug1 = response[0].data.suggestions.map((i) => ({
        //   ...i,
        //   suggestionType: "Point Addresses",
        //   text: removeLastPartARE(i.text),
        // }));
        // var sug2 = response[1].data.suggestions.map((i) => ({
        //   ...i,
        //   suggestionType: "Streets",
        //   text: removeLastPartARE(i.text),
        // }));
        // var sug3 = response[2].data.suggestions.map((i) => ({
        //   ...i,
        //   suggestionType: "Areas",
        //   text: removeLastPartARE(i.text),
        // }));
        // var sug4 = response[3].data.suggestions.map((i) => ({
        //   ...i,
        //   suggestionType: "Postal Locality",
        //   text: removeLastPartARE(i.text),
        // }));

        var allSug = sug0.concat(sug1, sug2, sug3, sug4);
        // var allSug = sug0.concat(sug1, sug2)

        if (allSug && allSug.length > 0) {
          var options = allSug.map((i) => ({
            id: i.magicKey,
            suggestion: i.text,
            suggestionType: i.suggestionType,
          }));

          setSuggestionsState({
            ...suggestionsState,
            isLoading: false,
            options: options,
          });
        } else {
          setSuggestionsState({
            ...suggestionsState,
            isLoading: false,
            options: [],
          });
        }
      })
      .catch((err) => {
        console.log("Error in gettingSuggestions ", err.message);
      })
      .then();

    return; //moved the below code to addressingClient.js so return from here
  };

  const getAddressResultBySuggestedSelection = (magicKey) => {
    if (!props.isAddressPanelOpen) props.openAddressPanel();
    reduxDispatch(fetchAddressResultRequest("Suggestion_Select", magicKey));
    const [promise, source] = getAddressCandidateByMkey(
      magicKey,
      props.appSettings.language
    );
    promise
      .then((resp) => {
        console.log(resp.data);
        var candidates = resp.data.candidates;
        reduxDispatch(fetchAddressResultSuccess(candidates));
      })
      .catch((err) => {
        console.log("Coundnt Fetch Address Detail ", err.message);
        const errMsg = err.message;
        reduxDispatch(fetchAddressResultFailure(errMsg));
      });
  };

  //const parcelIdPatter = new RegExp("^(\d{7}|\d{9})$"); //ParcelID RegEx 7 or 9 digits
  const isNumeric = (num) =>
    (typeof num === "number" ||
      (typeof num === "string" && num.trim() !== "")) &&
    !isNaN(num);

  const getAddressResultByUserSearchText = (search_text) => {
    if (!search_text || search_text.trim() < 1) return;
    search_text = search_text.trim();
    if (!props.isAddressPanelOpen) props.openAddressPanel();

    //Commented to disaply search by Parce id
    // if (
    //   isNumeric(search_text) &&
    //   search_text.length == 9 &&
    //   Number.isInteger(parseInt(search_text)) &&
    //   parseInt(search_text) > 0
    // ) {
    //   searchAddressByParcelId(search_text);
    //   return;
    // }

    reduxDispatch(fetchAddressResultRequest("Text_Search", search_text));
    //clear the previous search results also
    reduxDispatch(clearAddressDetails());
    //setSuggestionsState({isLoading:true, options :[] , query : ' ' ,disbled : true })
    const [promise, source] = getAddressCandidateByText(
      search_text,
      props.appSettings.language
    );
    promise
      .then((resp) => {
        if (resp.data.error) {
          console.log(
            "Unable to get address Candiate ",
            resp.data.error.code,
            "_",
            resp.data.eror.message
          );
          reduxDispatch(
            fetchAddressResultFailure(
              resp.data.error.code,
              "_",
              resp.data.eror.message
            )
          );
          return;
        }
        var candidates = resp.data.candidates;
        //setSuggestionsState({isLoading:false, options :[] , query : search_text ,disbled : false })
        reduxDispatch(fetchAddressResultSuccess(candidates));
      })
      .catch((err) => {
        //setSuggestionsState({isLoading:false, options :[] , query : search_text ,disbled : false })
        console.log("Coudnt Fetch Address Detail ", err.message);
        const errMsg = err.message;
        reduxDispatch(fetchAddressResultFailure(errMsg));
      });
  };

  const searchAddressByParcelId = (search_text) => {
    //console.log(" May be parcel id so will get details from Parcel Id");
    reduxDispatch(clearAddressDetails());
    reduxDispatch(fetchAddressResultRequest("Text_Search", search_text));
    const [promise, source] = getAddressDetailsFromParcelId(
      search_text,
      store_appToken
    );
    promise
      .then((resp) => {
        console.log(resp.data);
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          successObj,
          failedObj,
        } = addressingApiResponseMapper(resp.data);
        if (isSuccess) {
          var addressData = addressDetailsMapper(respData);
          var dipatchData = { ...addressData, isParcelSearch: true };
          reduxDispatch(fetchAddressResultSuccess([dipatchData]));
        } else {
          if (message === "No Records Found") {
            reduxDispatch(fetchAddressResultFailure(message)); //No Records Found
          }
          reduxDispatch(fetchAddressResultFailure(message));
        }
      })
      .catch((err) => {
        //setSuggestionsState({isLoading:false, options :[] , query : search_text ,disbled : false })
        console.log("Coudnt Fetch Address Detail From Parcel ID ", err.message);
        const errMsg = err.message;
        reduxDispatch(fetchAddressResultFailure(errMsg));
      });
  };

  const handleSuggestionSelected = (selected, evt) => {
    if (!selected || selected.length < 1) return;
    if (selected[0].customOption) {
      //custom search
      let user_entered_text = selected[0].suggestion.trim();
      if (!user_entered_text) return;

      getAddressResultByUserSearchText(user_entered_text);
    } else {
      var magic_key = selected[0].id;

      getAddressResultBySuggestedSelection(magic_key);
    }
  };

  //check & Remove- from code
  const searchAddressCandate = (text) => {
    if (!text || text.length < 1) return;

    setSuggestionsState({
      isLoading: true,
      options: [],
      query: " ",
      disbled: true,
    });

    reduxDispatch(fetchAddressResultRequest);
    const [promise, source] = getAddressCandidateByText(
      text,
      props.appSettings.language
    );
    promise
      .then((resp) => {
        console.log(resp.data);
        var candidates = resp.data.candidates;

        setSuggestionsState({
          isLoading: false,
          options: [],
          query: text,
          disbled: false,
        });

        reduxDispatch(fetchAddressResultSuccess(candidates));
      })
      .catch((err) => {
        setSuggestionsState({
          isLoading: false,
          options: [],
          query: text,
          disbled: false,
        });

        console.log("Coudnt Fetch Address Detail ", err.message);
        const errMsg = err.message;

        reduxDispatch(fetchAddressResultFailure(errMsg));
      });
  };

  const renderSuggestions = (results, menuProps, state) => {
    let index = 0;
    // results.pop()
    //results.push({id : "-1" , suggestion : state.text , suggestionType : "Search For"})
    //let cutomSuggestion = {id : "-1" , suggestion : state.text , suggestionType : "Search For"}
    //results.unshift(cutomSuggestion)
    const suggestionTypes = groupBy(results, "suggestionType");
    const items = Object.keys(suggestionTypes).map((type) => {
      return (
        <Fragment key={type}>
          <Menu.Header> {type} </Menu.Header>
          {/* <MenuItem> {JSON.stringify(suggestionTypes[type])}</MenuItem> */}
          {suggestionTypes[type].map((s) => {
            const item = (
              <MenuItem key={index} option={s} position={index}>
                <Highlighter search={state.text}>{s.suggestion}</Highlighter>
              </MenuItem>
            );
            index += 1;
            return item;
          })}
        </Fragment>
      );
    });

    // items.push(
    //   <Fragment>
    //     <Menu.Header> {"SearchFor"} </Menu.Header>
    //     <MenuItem key={index} option={state.text} position={index}>
    //       <Highlighter search={state.text}>
    //         {state.text}
    //       </Highlighter>
    //     </MenuItem>
    //   </Fragment>
    // );

    return <Menu {...menuProps}>{items}</Menu>;
    // const items = Object.keys(suggestionTypes).sort().map((type) => (
    //     <Fragment key={type}>
    //       {index !== 0 && <Menu.Divider />}
    //       <Menu.Header>{type}</Menu.Header>
    //       {
    //               suggestionTypes[type].map((i) => {
    //                   const item = (
    //                   <MenuItem key={index} option={i} position={index}>
    //                     <Highlighter search={state.text}> {i.suggestion} </Highlighter>
    //                   </MenuItem>
    //                 );

    //               index += 1;
    //               return item;
    //             })
    //       }
    //     </Fragment>
    //   ));

    //   return   <Menu {...menuProps}>{items}</Menu>;
    return (
      <Menu {...menuProps}>
        {results.map((result, index) => (
          <MenuItem option={result} position={index}>
            {result.suggestion}
          </MenuItem>
        ))}
      </Menu>
    );
  };

  //Render Suggestions with symobol / image for each option ..with allowNew
  //Yet to implement -- was not working for some reason -- to move the custom suggestion to the top
  const renderSuggestions2 = (results, menuProps, state) => {
    debugger;
    var posIndex = 1;

    const menuItems = results.map((result, index) => {
      if (result.customOption) {
        return (
          <MenuItem option={result} position={0} key={0}>
            {result.suggestion + "_custom"}
          </MenuItem>
        );
      } else {
        return (
          <MenuItem option={result} position={posIndex} key={posIndex}>
            {result.suggestion}
          </MenuItem>
        );
      }
      posIndex = +posIndex;
    });
    return <Menu {...menuProps}>{menuItems}</Menu>;

    return (
      <Menu {...menuProps}>
        {results.map((result, index) =>
          result.customOption ? (
            <MenuItem option={result} position={0}>
              {result.suggestion}
            </MenuItem>
          ) : (
            <MenuItem option={result} position={posIndex++}>
              {result.suggestion}
            </MenuItem>
          )
        )}
      </Menu>
    );
  };

  const [activeIndex, setActiveIndex] = useState(-1);
  // const onKeyDown = useCallback(
  //   (e) => {
  //     if (e.keyCode === 13 && activeIndex === -1) {
  //       console.log("Submit");
  //     }
  //   },
  //   [activeIndex]
  // );

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      if (!e.target.value) return;
      // searchAddressCandate(e.target.value)
      searchBarRef && searchBarRef.current.blur();
      //setSuggestionsState({isLoading:false, options :[] , query : ''})
      getAddressResultByUserSearchText(e.target.value);
    }
  };

  return (
    <>
      <div className={classes.mapSearchBarDesktop}>
        <AsyncTypeahead
          {...suggestionsState}
          ref={searchBarRef}
          id="typeahead"
          clearButton
          delay={400}
          emptyLabel="No results found"
          ignoreDiacritics={true}
          labelKey="suggestion"
          minLength={2}
          onSearch={handleSuggestionSearch}
          placeholder={t("searchplaceholder")}
          promptText="Enter Address"
          searchText="Searching...."
          filterBy={() => true}
          onChange={handleSuggestionSelected}
          allowNew={true}
          newSelectionPrefix={t("Searchfor")}
          //renderMenu ={renderSuggestions2}
          useCache={false}
          onKeyDown={onKeyDown}
          // onInputChange={(txt)=>{
          //   setSearchText(txt)
          // }}
        >
          {/* {(state) => setActiveIndex(state.activeIndex)} */}
        </AsyncTypeahead>
      </div>
      <div className={classes.mapSearchBarMobile}>
        <AsyncTypeahead
          {...suggestionsState}
          ref={searchBarRef}
          id="typeahead"
          clearButton
          delay={400}
          emptyLabel="No results found"
          ignoreDiacritics={true}
          labelKey="suggestion"
          minLength={2}
          onSearch={handleSuggestionSearch}
          placeholder={t("searchplaceholder")}
          promptText="Enter Address"
          searchText="Searching...."
          filterBy={() => true}
          onChange={handleSuggestionSelected}
          allowNew={true}
          newSelectionPrefix={t("Searchfor")}
          //renderMenu ={renderSuggestions2}
          useCache={false}
          onKeyDown={onKeyDown}
          // onInputChange={(txt)=>{
          //   setSearchText(txt)
          // }}
        >
          {/* {(state) => setActiveIndex(state.activeIndex)} */}
        </AsyncTypeahead>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    addressingResult: state.addressingResult,
    addressDetails: state.addressDetails,
    isAddressPanelOpen:
      state.mapPanelSetting.isSidePanelOpen &&
      state.mapPanelSetting.resultType === "address",
    appSettings: state.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openAddressPanel: () => {
      return dispatch(setSidePanelStatusAndResultType("true", "address")); //to display the sidePanel
    },
  };
};

const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export default connect(mapStateToProps, mapDispatchToProps)(MapSearchBar);
